import styled, {css} from "styled-components";
import {COLORS,MEDIA} from "utils/constants";
import React from "react"
// @ts-ignore
import {ButtonProps} from "@types/Types";
import Loader from "components/common/Loader";


const ButtonWrapper = styled.button<ButtonProps>`
  position: relative;
  padding: 0.7rem 1.4rem;
  height: 48px;
  min-height: 48px;
  max-height: 48px;
  font-style: normal;
  font-size: 14px;
  width: ${({fullWidth}: any) => fullWidth ? '100%' : 'fit-content'};
  min-width: ${({fullWidth}: any) => fullWidth ? '100%' : 'fit-content'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 0;
  border: 1px solid transparent;
  border-radius: 40px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 1px 2px 0;
  font-weight: bold;
  
  ${({small}) => small && css`
    font-size: 12px;
  `}
  
  ${({medium}) => medium && css`
    font-size: 14px;
  `}

  ${MEDIA.isMobile} {
    padding: 1rem 1.4rem;
    min-width: ${({fullWidth}: any) => fullWidth ? '100%' : 'fit-content'};
    width: ${({fullWidth}: any) => fullWidth ? '100%' : 'fit-content'};
    
    ${({small}) => small && css`
      height: 36px;
      min-height: 36px;
      font-weight: 500;
      border-radius: 40px;
      font-size: 12px;
    `}

    ${({medium}) => medium && css`
      font-weight: 700;
      border-radius: 40px;
      font-size: 14px;
      height: 38px;
      min-height: 38px;
    `}
  }

  &:hover {
    outline: 2px solid rgba(0, 0, 0, 0.15);
    transition: outline-width 0ms linear;
  }

  ${({danger, primary}) => danger && primary && css`
    background-color: ${COLORS.colorRed};
    color: ${COLORS.colorWhite};
    border-color: ${COLORS.colorRed};
  `}
  ${({danger, primary}) => !danger && primary && css`
    background-color: ${COLORS.primaryYellow};
    color: ${COLORS.primaryBlack};
    border-color: ${COLORS.colorBlack};
  `}
  ${({danger, primary}) => danger && !primary && css`
    background-color: ${COLORS.colorWhite};
    color: ${COLORS.colorRed};
    border-color: ${COLORS.colorRed};
  `}
  ${({danger, primary}) => !danger && !primary && css`
    background-color: ${COLORS.colorWhite};
    color: ${COLORS.primaryBlack};
    border-color: ${COLORS.primaryBlack};
  `}
  
  &:disabled {
    border-color: #767676 !important;
    color: #767676 !important;
    cursor: not-allowed;
    opacity: 0.8;
    ${({danger, primary}) => !danger && primary && css`
      border-color: ${COLORS.primaryBlack} !important;
    `}
    ${({danger, primary}) => danger && primary && css`
      border-color: ${COLORS.colorRed} !important;
    `}
  }

  a {
    text-decoration: none;
  }
`

const Button = React.forwardRef((props: ButtonProps, ref: any) => {
  return (
    <ButtonWrapper ref={ref} {...props} className={"button_effect"}>
      {props.loading ? <Loader size={"small"} color={props.primary ? props.danger ? COLORS.colorWhite : COLORS.primaryBlack : COLORS.primaryBlack}/> : props.children}
    </ButtonWrapper>
  )
})

export default Button
